import { render, staticRenderFns } from "./InputNumberElement.vue?vue&type=template&id=6fd1fbb4&scoped=true"
import script from "./InputNumberElement.vue?vue&type=script&lang=js"
export * from "./InputNumberElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd1fbb4",
  null
  
)

export default component.exports